import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    paddingBottom: '20px',
    ...theme.typography.body.PL,
  },
  twoColumn: {
    display: 'flex',
    flexBasis: '50%',
    justifyContent: 'space-between',
    maxWidth: '1000px', // Arbitrary number
    flexWrap: 'wrap',
    rowGap: '12px',
  },
  settings: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '410px',
  },
  iconLabel: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
}));

export default useStyles;

export const textFieldStyles = (theme) => ({
  label: {
    color: theme.colors.SMOKE,
    marginBottom: '0',
    width: '150px',
    fontSize: theme.fontSizes.DEFAULT,
  },
  itemHover: {
    color: theme.colors.CHARCOAL,
  },
  placeholder: {},
  textFieldInner: {
    borderRadius: '6px',
  },
  input: {
    color: theme.colors.SMOKE,
    fontSize: theme.fontSizes.DEFAULT,
  },
});

export const dropdownStyles = (theme) => ({
  label: {
    color: theme.colors.SMOKE,
    marginBottom: '0',
    width: '150px',
    fontSize: theme.fontSizes.DEFAULT,
  },
  itemHover: {
    color: theme.colors.CHARCOAL,
  },
  disabled: {
    color: theme.colors.SMOKE,
  },
  dropdownContentInner: {
    fontSize: theme.fontSizes.DEFAULT,
  },
});
